<template>
  <CModal
    :fullscreen="full_screen_modal_loading"
    size="xl"
    :backdrop="store.state.modal_static"
    :visible="visiable_var"
    @close="closed"
  >
    <CModalHeader
      dismiss
      @close="closed"
      class="d-flex justify-content-between"
    >
      <CModalTitle class="fs-14">
        ثبت بارگیری سفارش شماره
        {{ $store.state.order ? $store.state.order.order_id : '' }}
      </CModalTitle>
      <div>
        <font-awesome-icon
          icon="fa-solid fa-compress"
          size="lg"
          class="ms-4 p-1 c-pointer text-muted"
          @click="full_screen_modal_loading = false"
          v-if="full_screen_modal_loading"
        />
        <font-awesome-icon
          icon="fa-solid fa-expand"
          size="lg"
          class="ms-4 p-1 c-pointer text-muted"
          @click="full_screen_modal_loading = true"
          v-else
        />
      </div>
    </CModalHeader>
    <CModalBody>
      <div
        style="height: 300px"
        class="text-center d-flex"
        v-if="$store.state.loading_get_order"
      >
        <div class="m-auto">
          درحال خواندن اطلاعات
          <dots-loading />
        </div>
      </div>
      <template v-else-if="$store.state.order">
        <div class="row m-0">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1"
            v-if="$store.state.order.type_arz">
            <div class="bg-gray-1 p-1 px-3">
              <div class="d-flex justify-content-between">
                <div>
                  فی فروش ارزی
                  <template v-if="tax_percent">+ مالیات</template>
                </div>
                <div>
                  <span class="me-1" v-if="$store.state.order.type_arz">
                    {{ $store.state.order.price_per_ton_arz }}
                  </span>
                  <small>{{ $store.state.order.type_arz_title }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
            <div class="bg-gray-1 p-1 px-3">
              <div class="d-flex justify-content-between">
                <div class="">
                  فی فروش ریالی
                  <template v-if="tax_percent">+ مالیات</template>
                </div>
                <div>
                  {{ toNumberFormat(fe_with_tax) }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1"
            v-if="$store.state.order.tax_percent"
          >
            <div class="bg-gray-1 p-1 px-2">
              <div class="d-flex justify-content-between">
                <div class="">فی فروش خالص</div>
                <div class="">
                  <span class="me-1">{{ toNumberFormat(final_fe) }}</span>
                  <currency />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
            <div class="bg-gray-1 p-1 px-2">
              <div class="d-flex justify-content-between">
                <div>کرایه حمل هر تن</div>
                <div>
                  <base-icon icon="edit-note" class="nav-icon fs-20 p-1 align-middle c-pointer" @click="edit_rent_load_modal_visible = true" />
                  <span class="d-inline-block me-1">
                    {{ toNumberFormat($store.state.order.price_rent) }}
                    <currency />
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
            <div class="bg-gray-1 p-1 px-2">
              <div class="d-flex justify-content-between">
                <div class="">کرایه حمل کل</div>
                <div class="">
                  <span class="me-1">{{ toNumberFormat(price_haml_col) }}</span>
                  <currency />
                </div>
              </div>
            </div>
          </div>
          <template v-if="price_reward">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
              <div class="bg-gray-1 p-1 px-2">
                <div class="d-flex justify-content-between">
                  <div class="">انعام هر تن</div>
                  <div>
                    <span class="me-1">{{
                      toNumberFormat($store.state.order.price_reward)
                    }}</span>
                    <currency />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
              <div class="bg-gray-1 p-1 px-2">
                <div class="d-flex justify-content-between">
                  <div class="">انعام کل</div>
                  <div class="">
                    <span class="me-1">{{
                      toNumberFormat(price_reward_col)
                    }}</span>
                    <currency />
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
            <div class="bg-gray-1 p-1 px-2">
              <div class="d-flex justify-content-between">
                <div>مبلغ بار:</div>
                <div>
                  <span class="me-1">{{ toNumberFormat(total_price_fe) }}</span>
                  <currency />
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1"
            v-if="tax_percent"
          >
            <div class="bg-gray-1 p-1 px-2">
              <div class="d-flex justify-content-between">
                <div class="">
                  <span>مبلغ مالیات</span>
                </div>
                <div class="">
                  <span class="me-1">
                    {{ toNumberFormat(total_price_tax) }}
                  </span>
                  <currency />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
            <div class="bg-gray-1 p-1 px-2">
              <div class="d-flex justify-content-between">
                <div>مبلغ کل فاکتور</div>
                <div>
                  <span class="text-success me-1">
                    {{ toNumberFormat(total_price_all) }}</span>
                  <currency />
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3 px-1">
            <div class="bg-gray-1 p-1 px-2">
              <div class="d-flex justify-content-between">
                <div class="">تناژ کل</div>
                <div class="">
                  <span class="me-1">{{ total_ton }}</span>
                  <small class="text-muted">تن</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ltr m-0">
          <div class="col-12 col-md-5 border-right rtl">
            <div class="row">
              <div class="col-12 mb-3 px-1">
                <div class="bg-blue-1 p-1 px-3">
                  <div class="d-flex justify-content-between">
                    <span>نام مشتری</span>
                    <span>
                      <base-icon icon="edit-note" class="nav-icon fs-20 p-1 align-middle c-pointer" @click="edit_load_modal_visible = true" />
                      <b v-if="$store.state.order.load_type == 'warehouse_transfer'">حواله انبار</b>
                      <b v-else v-text="$store.state.order.user.fullname"></b>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 mb-3 px-1">
                <div class="bg-blue-1 p-1 px-3">
                  <div class="d-flex justify-content-between">
                    <span>نام کالا</span>
                    <span>
                      {{ $store.state.order.card_export.product.title }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 mb-3 px-1">
                <div class="bg-blue-1 p-1 px-3">
                  <div class="d-flex justify-content-between">
                    <div class="">شماره بارنامه</div>
                    <div class="">
                      <span>{{ $store.state.order.number_bar }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 mb-3 px-1">
                <div class="bg-blue-1 p-1 px-3">
                  <div class="d-flex justify-content-between">
                    <div class="pr-0 pl-1">تاریخ بارنامه</div>
                    <div class="p-0 text-right">
                      <span>
                        {{ to_jalali($store.state.order.date_number_bar) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-sm-6 mb-3 px-1">
                <div class="bg-blue-1 p-1 px-3">
                  <div class="d-flex justify-content-between">
                    <div class="pr-0 pl-1">حداکثر تناژ</div>
                    <div>{{ $store.state.order.max_ton_loaded }} تن</div>
                  </div>
                </div>
              </div>
              <div class="col-12 my-3 px-1">
                <license-plate :car="$store.state.order.car" />
              </div>
            </div>
          </div>

          <div class="col-12 col-md-7 rtl">
            <div class="row">
              <div class="col-12 col-sm-6 mb-3">
                <input-date
                  :radius_right="false"
                  selected="today"
                  v-model:value="date_loaded"
                  label="تاریخ بارگیری"
                  placeholder="تاریخ بارگیری را وارد کنید"
                />
              </div>

              <div class="col-12 content_referred">
                <layout-loading v-if="loading" />
                <p class="title_ref">حواله ها</p>
                <div
                  class="item_referred"
                  v-for="(referred, key) in all_referred"
                  :key="key"
                >
                  <font-awesome-icon
                    icon="fa-square"
                    class="remove_referred"
                    v-if="Object.keys(all_referred).length == 1"
                  />
                  <font-awesome-icon
                    icon="far fa-minus-square"
                    class="c-pointer remove_referred"
                    v-else
                    @click="removeReferred(key)"
                  />
                  <div class="item_body">
                    <div class="form-group me-1">
                      <input-ayandeh
                        type="number"
                        v-model:value="referred.referred_code"
                        :data-referred-key="key"
                        name="referred_codes[]"
                        @blur="processReferred(key)"
                        required
                        class="ltr text-left"
                        placeholder="کد حواله"
                      />
                    </div>
                    <div class="form-group">
                      <input-ayandeh
                        v-model:value="referred.referred_ton"
                        required
                        class="form-control ltr text-end"
                        placeholder="تناژ"
                      />
                    </div>
                    <template v-if="referred.kala_id && referred.kala_id !== ''">
                      <div
                        class="contract_det">
                        <p class="mb-0">
                          موجودی حواله:
                          <span
                            class="d-inline-block ltr text-info"
                            v-text="referred.remaining_inventory"></span>
                          <span class="text-muted ms-1">تن</span>
                        </p>
                        <p class="mb-0">
                          شماره قرارداد:
                          <span class="text-info">{{ referred.contract_code || '-/-' }}</span>
                        </p>
                      </div>
                      <div class="w-100 mt-2">
                        <div class="form-group w-100">
                          <label class="required mb-1">انتخاب انبار خروجی</label>
                          <select v-model="referred.anbar_id" required class="form-control">
                            <option value="">انتخاب</option>
                            <option
                              v-for="anb in $store.state.anbars_fm"
                              :key="anb.Cod"
                              :value="anb.Cod"
                              v-text="anb.Nam"
                            ></option>
                          </select>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div>
                  <font-awesome-icon
                    icon="fa-plus-square"
                    class="add_referred"
                    size="xl"
                    @click="addReferred"
                  />
                </div>
              </div>

              <div class="mt-4">
                <div
                  class="kalas_selected alert alert-info mb-3"
                  v-for="(kala, index_kala) in kalas"
                  :key="index_kala"
                >
                  <div class="row">
                    <div class="col-12 mb-2">
                      <b class="mb-0" v-text="kala.kala_title"></b>
                    </div>
                    <div class="col-12 mb-2">
                      <span>حواله ها : </span>
                      <b class="mb-0" v-text="kala.referreds_code_text"></b>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <span>موجودی کل کالا : </span>
                      <b
                        class="mb-0"
                        v-text="kala.kala_remaining_inventory"
                      ></b>
                    </div>
                    <div class="col-12 col-sm-6 mb-2">
                      <span>درصد بازاریابی : </span>
                      <b class="mb-0" v-text="kala.percent_vis || '-/-'"></b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

      <edit-load-modal v-model="edit_load_modal_visible"
                       :load="$store.state.order"
                       @updated="updatedLoad"
      ></edit-load-modal>

      <edit-rent-modal v-model="edit_rent_load_modal_visible"
                       :load="$store.state.order"
                       @updated="updatedLoad"
      ></edit-rent-modal>
    </CModalBody>
    <CModalFooter class="ltr" v-if="$store.state.order">
      <btn-ayandeh label="انصراف" color="light" @click="closed" />
      <btn-ayandeh
        color="info"
        class="ms-1"
        @click="submit_form"
        :disabled="disabled_btn_submit"
        :loading="loading_submit"
        label="بارگیری"
      />
    </CModalFooter>
  </CModal>
</template>


<script setup>
import {ref, computed, watch, onMounted, defineProps, getCurrentInstance} from 'vue'
import { useStore } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'
import LicensePlate from '@/components/partial/LicensePlate'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import LayoutLoading from '@/components/loading/LayoutLoading'
import InputAyandeh from '@/components/inputs/InputAyandeh'
import InputDate from '@/components/inputs/InputDate'
import BaseIcon from "@/components/base/BaseIcon.vue"
import EditLoadModal from "@/components/Load/EditLoadModal.vue"
import EditRentModal from "@/components/Load/EditRentModal.vue"


const props = defineProps({
  order_id: {
    type: Number,
    default: null,
    required: true,
  },
  visiable: {
    type: Boolean,
    default: false,
  },
})

const { proxy } = getCurrentInstance()
const emit = defineEmits(['update:visiable', 'loaded', 'loadUpdated', 'closed'])

// 🧠 Store
const store = useStore()

// 🧩 Reactive state
const visiable_var = ref(false)
const loading_get_order = ref(false)
const full_screen_modal_loading = ref(false)
const anbars = ref([])
const multi_product = ref(false)
const loading = ref(false)
const date_loaded = ref('')
const kalas = ref([])
const loading_submit = ref(false)
const source_ref = ref(null)
let edit_load_modal_visible = ref(false)
let edit_rent_load_modal_visible = ref(false)

const default_referred_value = {
  kala_id: '',
  kala_title: '',
  referred_code: '',
  referred_ton: '',
  contract_code: '',
  remaining_inventory: '',
  kala_remaining_inventory: '',
  anbar_id: 2,
}

const all_referred = ref(() => [])

// 🧮 Computed
const fe_with_tax = computed(() => {
  const order = store.state.order
  if (order?.type_arz) {
    return order.price_per_ton_arz * order.price_arz
  }
  return order?.price_per_ton || 0
})

const storeload = (data) => store.commit('storeOrder', data)

const tax_percent = computed(() => store.state.order?.tax_percent || 0)
const final_fe = computed(() => (fe_with_tax.value / (100 + tax_percent.value)) * 100)
const fe_tax = computed(() => (final_fe.value / 100) * tax_percent.value)
const total_ton = computed(() => proxy.$sum('referred_ton', all_referred.value))
const total_price_tax = computed(() => fe_tax.value * total_ton.value)
const total_price_fe = computed(() => parseFloat((final_fe.value * total_ton.value).toFixed(2)))
const price_haml_col = computed(() => (store.state.order?.price_rent || 0) * total_ton.value)
const price_reward_col = computed(() => (store.state.order?.price_reward || 0) * total_ton.value)
const total_price_all = computed(() =>
  total_price_fe.value + price_haml_col.value + price_reward_col.value + total_price_tax.value
)
const disabled_btn_submit = computed(() => {
  if (loading_submit.value) return true
  if (
    all_referred.value.some(
      (x) => !x.referred_code || x.referred_ton == '' || x.referred_ton == 0 || x.anbar_id == ''
    )
  ) return true

  if (
    Object.keys(kalas.value).length &&
    !store.state.default_anbar_fm &&
    Object.entries(kalas.value).some((x) => x[1].anbar_id == '')
  ) return true

  return false
})


// ⚙️ Lifecycle
onMounted(() => {
  // store.dispatch('get_default_anbar_fm')
  store.dispatch('get_anbars_fm')
  if (proxy.$cookie.get('f_s_loading')) {
    full_screen_modal_loading.value = true
  }

  all_referred.value = [{ ...default_referred_value }]
})

// 🧭 Watchers
watch(() => props.visiable, (newVal) => {
  visiable_var.value = newVal
  if (newVal) {
    store.dispatch('get_order', props.order_id)
  }
})

watch(full_screen_modal_loading, (newVal) => {
  setCookie('f_s_loading', newVal)
})

// 🧩 Methods

const updatedLoad = (newData) => {
  storeload(newData.load_detail_template)
  emit('loadUpdated', newData.load_list_template)
}
function reset_modal() {
  visiable_var.value = false
  loading_get_order.value = false
  multi_product.value = false
  loading.value = false
  loading_submit.value = false
  kalas.value = []
  all_referred.value = [{...default_referred_value}]
  storeload(null)
}

function closed() {
  reset_modal()
  visiable_var.value = false
  emit('update:visiable', visiable_var.value)
  emit('closed')
}

function removeReferred(index) {
  all_referred.value.splice(index, 1)
}

function addReferred() {
  all_referred.value.push({ ...default_referred_value })
}

function processReferred(key) {
  if (!all_referred.value[key].referred_code) return false
  if (source_ref.value) source_ref.value.cancel()

  const referred_codes = []
  let duplicate

  all_referred.value.forEach((referred) => {
    referred.contract_code = ''
    duplicate = referred_codes.find((element) => element === referred.referred_code)
    if (duplicate) return false
    referred_codes.push(referred.referred_code)
  })

  if (duplicate) {
    proxy.$my_alert(`کد حواله ${duplicate} قبلاً وارد شده است`, 'error')
    return false
  }

  loading.value = true
  source_ref.value = axios.CancelToken.source()

  axios.post('/orders/process_referred_code', {
    referred_codes,
    product_id: store.state.order.product_id,
    multi_product: multi_product.value,
  }, {
    cancelToken: source_ref.value.token,
  })
    .then((response) => {
      if (response?.data?.status === 'success') {
        kalas.value = response.data.kalas

        all_referred.value.forEach((referred) => {
          const sss = response.data.referreds[referred.referred_code]
          referred.contract_code = sss.contract.contract_code
          referred.remaining_inventory = sss.remaining_inventory
          referred.kala_remaining_inventory = response.data?.kalas[sss.kala_id]?.kala_remaining_inventory || 0
          referred.percent_vis = sss.percent_vis
          referred.kala_title = sss.kala_title
          referred.kala_id = sss.kala_id
        })
      } else if (response?.data?.status === 'warning') {
        Swal.fire({
          title: 'فاکتور چند ردیفه',
          text: 'آیا می‌خواهید در این فاکتور کالاهای مختلفی را بارگیری کنید؟',
          showDenyButton: true,
          confirmButtonText: 'بله',
          denyButtonText: 'خیر',
        }).then((result) => {
          if (result.isConfirmed) multi_product.value = true
          else removeReferred(Object.keys(all_referred.value).length - 1)
          processReferred(key)
        })
      } else if (response?.data.status === 'error') {
        proxy.$my_alert(response.data.message, 'error')
      }
    })
    .catch(e => {
      // proxy.$my_alert(e.message, 'error')
    })
    .finally(() => {
      loading.value = false
    })
}

function submit_form() {
  loading_submit.value = true

  axios.post('/orders/set_load', {
    order_id: props.order_id,
    date_loaded: date_loaded.value,
    all_referred: all_referred.value,
  })
    .then(({ data }) => {
      if (data.status === 'success') {
        closed()
        emit('loaded')
      } else {
        proxy.$my_alert(data.message, data.status)
      }
    })
    .catch(error => {
      proxy.$my_alert(error.message, 'error')
    })
    .finally(() => {
      loading_submit.value = false
    })
}
</script>

